module.exports = __webpack_public_path__ + "static/img/RZ_pic10.9a9da0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/RZ_pic10.png
// module id = Cbpx
// module chunks = 5